<ng-container [ngSwitch]="this.model?.type">
  <pg-input-factory
    *ngSwitchCase="'input'"
    [model]="this.model.data"
    [parentFormGroup]="this.parentFormGroup"
  ></pg-input-factory>
  <pg-radio-factory
    *ngSwitchCase="'radio'"
    [model]="this.model.data"
    [parentFormGroup]="this.parentFormGroup"
  ></pg-radio-factory>
  <pg-checkbox-factory
    *ngSwitchCase="'checkbox'"
    [model]="this.model.data"
    [parentFormGroup]="this.parentFormGroup"
  ></pg-checkbox-factory>
  <pg-button-factory
    *ngSwitchCase="'button'"
    [model]="this.model.data"
    [parentFormGroup]="this.parentFormGroup"
  ></pg-button-factory>
  <pg-text-content-factory
    *ngSwitchCase="'text'"
    [model]="this.model.data"
  ></pg-text-content-factory>
  <!-- <pg-image-factory
    *ngSwitchCase="'image'"
    [model]="this.model.data"
  ></pg-image-factory> -->
  <pg-action-text-factory
    *ngSwitchCase="'action-text'"
    [model]="this.model.data"
    [parentFormGroup]="parentFormGroup"
  ></pg-action-text-factory>
  <pg-badge-factory
    *ngSwitchCase="'badge'"
    [model]="this.model.data"
  ></pg-badge-factory>
  <pg-list-select-factory
    *ngSwitchCase="'list-select'"
    [model]="this.model.data"
    [parentFormGroup]="parentFormGroup"
  ></pg-list-select-factory>
  <pg-switch-factory
    *ngSwitchCase="'switch'"
    [model]="this.model.data"
    [parentFormGroup]="this.parentFormGroup"
  ></pg-switch-factory>
  <pg-linear-loader-factory
    *ngSwitchCase="'linear-loader'"
    [model]="this.model.data"
  ></pg-linear-loader-factory>
  <pg-calendar-factory
    *ngSwitchCase="'calendar'"
    [model]="this.model.data"
    [parentFormGroup]="this.parentFormGroup"
  >
  </pg-calendar-factory>
  <pg-state-select-input
    *ngSwitchCase="'state-select'"
    [model]="this.model.data"
    [parentFormGroup]="this.parentFormGroup"
  >
  </pg-state-select-input>
  <!-- <pg-custom-component-factory
    *ngSwitchCase="'custom'"
    [model]="this.model.data"
    [parentFormGroup]="this.parentFormGroup"
  >
  </pg-custom-component-factory> -->
</ng-container>
